import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DateTime } from 'luxon';

@Pipe({
  name: 'officeTime',
})

export class OfficeTimePipe implements PipeTransform {
  transform(value: any): string {
    if(!value) return ''

    // Create a Luxon DateTime with the time zone set
    const date = DateTime.fromJSDate(new Date(value)).setZone('America/Los_Angeles');

    // Check for valid date
    if (!date.isValid) {
      return ''; // Return an empty string or handle invalid date
    }

    // Format the date with the time zone
    const sfoDateTime = `${date.toFormat('MMM d, yyyy, hh:mm a')} ${date.offsetNameShort}`;

    return sfoDateTime;
  }
}

